import { pipe } from 'ramda';
import type { Maybe } from 'core/maybe';
import { flatMap, Just, map, Nothing } from 'core/maybe';
import { Versioned } from 'core/versioned';
import { Serializer } from 'hooks/use-local-storage';

type ColumnOrder = Versioned<1, string[]> | Versioned<2, string[]>;

const toLatest = ([[, version], data]: ColumnOrder): Maybe<
  Versioned<2, string[]>
> => (version === 2 ? Just(Versioned.of<2, string[]>(2)(data)) : Nothing());

export const COLUMN_ORDER_SERIALIZER: Serializer<string[]> = {
  deserialize: pipe(
    map((x: string) => JSON.parse(x) as ColumnOrder),
    flatMap(toLatest),
    map(Versioned.value),
  ),
  serialize: pipe(Versioned.of(2), JSON.stringify),
};
